import {
  StepLabel as MuiStepLabel,
  stepLabelClasses as MuiStepLabelClasses,
  type StepLabelProps as MuiStepLabelProps,
} from '@mui/material';

export type StepLabelProps = MuiStepLabelProps;

export const StepLabel = MuiStepLabel;
export const stepLabelClasses = MuiStepLabelClasses;
